/* eslint-disable */
import React, { Component } from 'react';
import HTMLText from './HTMLText'

class CheckBox extends Component {

	constructor(props) {
		super(props);
		
		this.state = {	
			name : this.props.name,		
			className : this.props.className,
			dataField : this.props.dataField,
			value : this.props.value,
			text : this.props.text,
			curValue:this.props.curValue,
			maxCheck:this.props.maxCheck
		};
		this.onChange = this.onChange.bind(this);
	}
	
	componentDidMount() {		
	}
	
	componentWillUnmount() {
	}

	componentWillReceiveProps(nextProps) {
		
		this.setState({maxCheck:nextProps.maxCheck,className:nextProps.className, value:nextProps.value,text : nextProps.text,curValue : nextProps.curValue});

	} 
	
	

	onChange(e){
		var value = e.target.value;
		var checkedValue = this.state.curValue.slice(); 		
		if (checkedValue == null || checkedValue == ""){
			checkedValue = []
		}
		var hasValue = false;
		for( var i = 0; i < checkedValue.length; i++){ 
			if ( checkedValue[i] == value) {
				checkedValue.splice(i, 1); 
				hasValue=true;
			}
		}			
		if (!hasValue){
			if (this.state.maxCheck && this.state.maxCheck>0 && checkedValue.length >= this.state.maxCheck){
				return;
			}	
			checkedValue.push(value);
		}
		
		this.props.parent.setState({[this.props.dataField]:checkedValue});
	
	}


	render() {
		var checkedValue = this.state.curValue.slice(); 
		var hasValue = false;
		for( var i = 0; i < checkedValue.length; i++){ 			
			if ( checkedValue[i] == this.state.value) {				
				hasValue=true;
				break;
			}
		}
		
		return (
			<React.Fragment>
				<div className={this.props.className} >
					<input type="checkbox" name={this.props.name} value={this.state.value} 
						checked={hasValue} onChange={this.onChange} id={this.props.name + this.props.value}/>
					<label htmlFor={this.props.name + this.props.value}>
						<HTMLText text={this.state.text}/>
					</label>
				</div>
			</React.Fragment>			
		);
	}
}




export default CheckBox;